import { observable } from 'mobx';
import { noop } from '@src/utils/common-util';
import TinyInputStore from '@src/components/tiny-input/store';
import ZtServiceFactory from '@src/services/zt';
import lockAsync from '@src/utils/lock-async';
import captchaHandlerDecorate from '@src/utils/captcha-deco-util';
import { autobind } from 'core-decorators';
import { useRequest } from 'ahooks';
import AntdMessage from '../../components/antd/message';
import { useEffect } from 'react';
import $$tracker from '@src/tracker';
import { deviceId, getUaOs, getUtmSource, operateFrom, getParameterByNames } from '@src/utils/device';
import { semTracker } from '@src/sem-tracker/index';
class AppointmentModalStore {
  /**
   * store中初始化service接口变量
   */
  $ztService = ZtServiceFactory.getDefaultInstance();
  // 手机号码输入框
  phoneInputStore = new TinyInputStore();
  // 验证码输入框
  smsInputStore = new TinyInputStore();

  @observable isOpen;
  @observable closeCallback = noop;
  @observable list = [{ value: 'Android', label: '安卓' }, { value: 'iOS', label: '苹果' }, { value: '鸿蒙', label: '鸿蒙' }];
  // 选择系统
  @observable platformLabel = '';
  @observable platform = '';
  // 勾选协议
  @observable agreementType = false;
  // 预约方式 true扫码预约 false手机号预约
  @observable AppointmentMethod = true;
  // 1未预约/ 2预约成功
  @observable modalType = 1;
  // 是否首次预约（1：是，0：否）
  @observable is_frist;
  // 好友邀请uid
  @observable friendInvitesUid;
  // 好友手机号
  @observable friendInvitesPhone;
  // title
  @observable textTitle = '请先预约';
  // 小程序二维码
  @observable qrcodeImg = '';

  @observable phone = '';

  constructor(options = {}) {
    Object.assign(this, options);
  }

  clickStopPropagation(e) {
    e.stopPropagation();
  }

  /**
   * 点击关闭弹窗
   * 重写关闭事件, 补充了弹窗特定的关闭回调
   */
  onClickClose = () => {
    this.isOpen = false;
    this.onClose();
  };

  // 勾选系统
  clickPlatform(item) {
    if (this.platform === item.value) return;
    this.platform = item.value;
    this.platformLabel = item.label;
  }
  // 勾选协议
  clickAgreement() {
    this.agreementType = !this.agreementType;
  }
  // 切换预约方式
  onswitchingAppointmentMethod() {
    this.AppointmentMethod = !this.AppointmentMethod;
    if (this.AppointmentMethod) {
      $$tracker.clickGoReservationSaoma();
    } else {
      $$tracker.clickGoReservationPhone();
    }
    this.switchSuccess();
  }
  switchSuccess = () => {};

  // 验证
  onAppointmentClick = () => {
    if (!this.phoneInputStore.value) {
      AntdMessage.error('手机号未填写-请填写~');
    } else if (!/^1[3-9]\d{9}$/.test(this.phoneInputStore.value)) {
      AntdMessage.error('手机号格式填写有误，请重新填写后提交~');
    } else if (!this.smsInputStore.value) {
      AntdMessage.error('验证码未填写-请填写~');
    } else if (!/^\d+$/.test(this.smsInputStore.value)) {
      AntdMessage.error('验证码格式填写有误-请重新填写后提交~');
    } else if (this.platform === '') {
      AntdMessage.error('请选择手机类型~');
    } else if (!this.agreementType) {
      AntdMessage.error('请勾选隐私协议~');
    } else {
      // 走激活接口
      this.subscribe(this.smsInputStore.value, this.friendInvitesUid ? this.friendInvitesUid : '', this.phoneInputStore.value, this.platform);
    }
  };

  // 获取手机号验证码
  getPhoneCodeAsync(params) {
    return this.$ztService
      .getPhoneCode(params)
      .then(() => {})
      .catch(err => {
        const { code, message } = err?.serviceResponse;
        AntdMessage.error(message);
      });
  }

  // 预约
  subscribe(code, invitee_uid, phone, platform) {
    const ua_os = getUaOs();
    const utm_source = getUtmSource();
    const device_id = deviceId;
    const operate_from = operateFrom;
    const _btcode = getParameterByNames('_btcode');
    const bd_vid = getParameterByNames('bd_vid');
    return this.$ztService
      .subscribe(code, device_id, invitee_uid, operate_from, phone, platform, ua_os, utm_source)
      .then(res => {
        $$tracker.clickReservationNow(this.platformLabel, 'success', '');
        // 变天买量埋点
        semTracker.send({ eventId: 'btForm', context: '表单提交成功', _btcode, bd_vid, web_url: window.location.href });
        this.is_frist = res?.is_frist;
        this.modalType = 2;
        // 不让预约后刷新状态出现提示弹窗
        sessionStorage.setItem('friendInvitesShowTips', '1');
        this.updataConfig();
      })
      .catch(err => {
        const { code, message } = err?.serviceResponse;
        $$tracker.clickReservationNow(this.platformLabel, 'fail', message);
        AntdMessage.error(message);
      });
  }

  updataConfig = () => {};

  // 退出

  /**
   * 发送验证码
   * @param authParams
   * @returns {Promise<boolean>}
   */
  @autobind
  @lockAsync()
  @captchaHandlerDecorate('zt')
  async onSendVCRequest({ ...authParams }) {
    try {
      await this.sendCodeRequest.run({ ...authParams });
      // message.success('验证码已发送, 请注意查收');
      $$tracker.clickGainCode('success', '');
      return true;
    } catch (err) {
      const { code, message } = err?.serviceResponse;
      $$tracker.clickGainCode('fail', message);
      AntdMessage.error(message);
      return false;
    }
  }

  use() {
    // 发送短信验证码接口
    this.sendCodeRequest = useRequest(async params => await this.getPhoneCodeAsync(params), { manual: true, throwOnError: true });

    useEffect(
      () => {
        if (this.modalType === 1) {
          if (!this.phone) {
            this.modalType = 1;
          } else {
            this.modalType = 2;
          }
        }
      },
      [this.phone]
    );
  }
}

export default AppointmentModalStore;
